module.exports = __webpack_public_path__ + "static/media/hero_img_hourly.1aca8972.png";